import { motion } from "framer-motion";
import { ASSETS, HERO } from "../../data/content";

export default function Hero() {
  return (
    <section
      id="top"
      data-testid="hero-section"
      className="relative h-screen min-h-[700px] w-full overflow-hidden bg-[#050B14] grain-overlay"
    >
      {/* Video background */}
      <video
        data-testid="hero-video"
        className="absolute inset-0 w-full h-full object-cover bg-[#050B14]"
        autoPlay
        muted
        loop
        playsInline
        preload="auto"
      >
        <source src={ASSETS.heroVideo} type="video/mp4" />
      </video>

      {/* Cinematic overlay */}
      <div className="absolute inset-0 bg-gradient-to-b from-[#050B14]/65 via-[#050B14]/30 to-[#050B14]" />
      <div className="absolute inset-0 bg-gradient-to-r from-[#050B14]/70 via-transparent to-transparent" />

      {/* Top hairline */}
      <div className="absolute top-0 left-0 right-0 h-px bg-white/10 z-10" />

      {/* Content */}
      <div className="relative z-10 h-full flex flex-col justify-end pb-28 md:pb-40 max-w-[1600px] mx-auto px-6 md:px-12">
        <div className="grid grid-cols-12 gap-6 items-end">
          <div className="col-span-12 lg:col-span-8">
            <motion.div
              initial={{ opacity: 0, y: 30 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.4, ease: [0.22, 1, 0.36, 1] }}
            >
              <div className="flex items-center gap-4 mb-8">
                <div className="h-px w-12 bg-[#E5D3B3]" />
                <span className="overline">{HERO.overline}</span>
              </div>
              <h1
                data-testid="hero-headline"
                className="font-serif-display text-white text-[clamp(2.75rem,6.5vw,6.5rem)] leading-[1.02] font-light tracking-[-0.02em] whitespace-pre-line"
              >
                {HERO.title}
              </h1>
            </motion.div>
          </div>

          <div className="col-span-12 lg:col-span-4 lg:pl-8">
            <motion.p
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.4, delay: 0.4, ease: [0.22, 1, 0.36, 1] }}
              data-testid="hero-subhead"
              className="text-[#D4C9A8] text-base md:text-lg font-light leading-relaxed tracking-wide max-w-md"
            >
              {HERO.subhead}
            </motion.p>

            <motion.div
              initial={{ opacity: 0, y: 20 }}
              animate={{ opacity: 1, y: 0 }}
              transition={{ duration: 1.4, delay: 0.7, ease: [0.22, 1, 0.36, 1] }}
              className="mt-10 flex flex-col sm:flex-row gap-4"
            >
              <a
                href="#specifications"
                data-testid="hero-cta-specs"
                className="btn-primary"
              >
                {HERO.ctaPrimary}
              </a>
              <a
                href="#founder"
                data-testid="hero-cta-provenance"
                className="btn-ghost"
              >
                {HERO.ctaSecondary}
              </a>
            </motion.div>
          </div>
        </div>
      </div>

      {/* Scroll indicator */}
      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 2, duration: 1.5 }}
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 flex flex-col items-center gap-4 text-white/60"
        aria-hidden="true"
      >
        <span className="overline text-[10px] text-white/50">Scroll</span>
        <motion.div
          className="w-px h-12 bg-gradient-to-b from-[#E5D3B3] to-transparent"
          animate={{ scaleY: [0.3, 1, 0.3], originY: 0 }}
          transition={{ duration: 2.4, repeat: Infinity, ease: "easeInOut" }}
        />
      </motion.div>
    </section>
  );
}
